module.exports = __webpack_public_path__ + "img/defaultImage.37d63523.jpg";